import get from 'lodash/get';
import { getModify, userCompleteModify } from 'services/api/user/modify';
import RequestManager from 'requests/RequestManager';
import DeviceListTask from 'requests/tasks/user/DeviceListTask';
import { getUserIsLoggendin } from 'containers/User/service';
import RentHistoryTask from 'requests/tasks/user/RentHistoryTask';
import GetUserTask from 'requests/tasks/SocialTasks/GetUserTask';
import PaywayDataTask from 'requests/tasks/PaywayDataTask';
import PaywayListPaymentMethodTask from 'requests/tasks/user/PaywayListPaymentMethodTask';
import StatusControlPinTask from 'requests/tasks/user/controlPin/statusControlPinTask';
import SetControlPinTask from 'requests/tasks/user/controlPin/SetControlPinTask';
import RemindControlPinTask from 'requests/tasks/user/controlPin/RemindControlPinTask';
import PaywayProfileTask from 'requests/tasks/PaywayProfileTask';
import Utils from 'utils/Utils';
import {
  setProfileLastTouch,
  setProfileLastTouchFavorited,
} from 'utils/Socialization';
import { removeModal, showModal } from 'actions/response';
import { execSafePushSession } from 'utils/getStickySession';
import {
  COMPLETE_MY_INFO_PENDING,
  COMPLETE_MY_INFO_SUCCESS,
  COMPLETE_MY_INFO_ERROR,
} from 'actions/user';
import { getRegion } from 'utils/Region';
import { getPaywayProfileService } from 'api/services/payway';

export const CONST_SET_INFO = 'SET_INFO';
export const setInfo = info => ({ type: CONST_SET_INFO, info });

export const IS_LOGGED_IN_PROFILE = 'IS_LOGGED_IN_PROFILE';
export const setProfile = profile => ({ type: IS_LOGGED_IN_PROFILE, profile });

export const CONST_SET_RENT_HISTORY = 'SET_RENT_HISTORY';
export const setRentHistory = rentHistory => ({
  type: CONST_SET_RENT_HISTORY,
  rentHistory,
});

export const CONST_SET_DEVICES = 'SET_DEVICES';
export const setDevices = devices => ({
  type: CONST_SET_DEVICES,
  devices,
});

export const CARD_VIEW_SET_SEEN_LAST = 'CARD_VIEW_SET_SEEN_LAST';
export const setSeenLast = (seenLast = {}) => ({
  type: CARD_VIEW_SET_SEEN_LAST,
  seenLast,
});

export const CONST_DETACH = 'DETACH_DEVICES';
export const detach = data => ({
  type: CONST_DETACH,
  data,
});

export const CONST_SET_SOCIAL_PROFILE = 'SET_SOCIAL_PROFILE';
export const setSocialProfile = profile => ({
  type: CONST_SET_SOCIAL_PROFILE,
  profile,
});

export const CONST_REMOVE_USER_SUSC = 'REMOVE_USER_SUSC';
export const setRemoveUserSusc = purchase_id => ({
  type: CONST_REMOVE_USER_SUSC,
  purchase_id,
});

export const CONST_SET_PAYWAY_DATA = 'SET_PAYWAY_DATA';
export const setPaywayData = paywayData => ({
  type: CONST_SET_PAYWAY_DATA,
  paywayData,
});

export const CONST_SET_PAYWAY_PROFILE = 'SET_PROFILE_DATA';
export const setPaywayProfile = paywayProfile => ({
  type: CONST_SET_PAYWAY_PROFILE,
  paywayProfile,
});

export const CONST_SET_PAYWAY_LIST_PAYMENT_METHOD =
  'SET_PAYWAY_LIST_PAYMENT_METHOD';
export const setPaywayListPaymentMethod = listPaymentMethod => ({
  type: CONST_SET_PAYWAY_LIST_PAYMENT_METHOD,
  listPaymentMethod,
});

export const CONST_SET_STATUS_CONTROL_PIN = 'CONST_SET_STATUS_CONTROL_PIN';
export const setStatusControlPin = statusControlPin => ({
  type: CONST_SET_STATUS_CONTROL_PIN,
  statusControlPin,
});

export const deviceDetach = data => dispatch => {
  dispatch(detach(data));
};

export const CONST_SET_CONFIRM_CONTROL_PIN = 'CONST_SET_CONFIRM_CONTROL_PIN';
export const setConfirmControlPin = statusPinCodeSet => ({
  type: CONST_SET_CONFIRM_CONTROL_PIN,
  statusPinCodeSet,
});

export const CONST_SET_REMIND_CONTROL_PIN = 'CONST_SET_REMIND_CONTROL_PIN';
export const setRemindControlPin = remindControlPin => ({
  type: CONST_SET_REMIND_CONTROL_PIN,
  remindControlPin,
});

export const CONST_REMOVE_REMIND_CONTROL_PIN =
  'CONST_REMOVE_REMIND_CONTROL_PIN';
export const removeRemind = () => ({
  type: CONST_REMOVE_REMIND_CONTROL_PIN,
});

export const CONST_SET_UPDATE_CONTROL_PIN = 'CONST_SET_UPDATE_CONTROL_PIN';
export const setUpdateControlPin = data => ({
  type: CONST_SET_UPDATE_CONTROL_PIN,
  data,
});

export const CONST_SET_DEVICES_BY_PURCHASE_ID =
  'CONST_SET_DEVICES_BY_PURCHASE_ID';
export const setDevicesByPurchaseId = devices => ({
  type: CONST_SET_DEVICES_BY_PURCHASE_ID,
  devices,
});

export const CONST_SET_USER_MODIFY = 'CONST_SET_USER_MODIFY';
export const setUserModify = data => ({
  type: CONST_SET_USER_MODIFY,
  data,
});

export const CONST_SET_ERROR_EMAIL_EXIST = 'CONST_SET_ERROR_EMAIL_EXIST';
export const setErrorEmailExist = data => ({
  type: CONST_SET_ERROR_EMAIL_EXIST,
  data,
});

export const CONST_SET_NEW_USER_NAME = 'CONST_SET_NEW_USER_NAME';
export const setNewUserName = data => ({
  type: CONST_SET_NEW_USER_NAME,
  data,
});

export const CONST_SET_TERMS_AND_CONDITIONS = 'CONST_SET_TERMS_AND_CONDITIONS';
export const setTermsAndConditions = acceptTerms => ({
  type: CONST_SET_TERMS_AND_CONDITIONS,
  acceptTerms,
});

export const CONST_SET_USER_TYPE_LITE = 'CONST_SET_USER_TYPE_LITE';
export const setUserTypeLite = userTypeLite => ({
  type: CONST_SET_USER_TYPE_LITE,
  userTypeLite,
});

export const CONST_SET_USER_TOKEN = 'CONST_SET_USER_TOKEN';
export const setUserToken = userToken => ({
  type: CONST_SET_USER_TOKEN,
  userToken,
});

export const CONST_UPDATE_NEW_SESSION = 'CONST_UPDATE_NEW_SESSION';
export const setNewUserSession = userData => ({
  type: CONST_UPDATE_NEW_SESSION,
  userData,
});

// User
export const getSocialProfile = gamificationId => dispatch => {
  const socialTask = new GetUserTask(gamificationId);
  RequestManager.addRequest(socialTask)
    .then(result => {
      const partnerInfo = !result.data.partners
        ? []
        : result.data.partners.filter(p => p.name === 'clv');
      const partnerName = partnerInfo.length === 0 ? '' : partnerInfo[0].name;
      const partnerUserId =
        partnerInfo.length === 0 ? '' : partnerInfo[0].keys.partnerUserId;
      const profile = {
        id: result.data.id,
        username: Utils.decode_utf8(result.data.metadatas.name),
        isPrivate: result.data.config.isPrivate || false,
        partnerName,
        partnerUserId,
      };
      dispatch(setSocialProfile(profile));
    })
    .catch(() => {});
};

export const isLoggedIn = metadata => dispatch =>
  getUserIsLoggendin({
    claroLiteConfig:
      JSON.parse(metadata?.cv_advertising_config || '{}')?.[getRegion()]
        ?.enable ||
      JSON.parse(metadata?.cv_advertising_config || '{}')?.default?.enable,
  })
    .then(data => {
      execSafePushSession(get(data, ['response'], {}))
        .then(resp => {
          if (resp.status !== 200) {
            const message = window.utils.getMeta.translations(
              get(resp, 'errors.code', 'PGS-CHM-00001'),
            );
            dispatch(
              showModal({
                modalType: 'RetryPushSession',
                props: {
                  message,
                  onRetry: () => window.location.reload(),
                },
              }),
            );
          }
        })
        .catch(err => {
          dispatch(removeModal(''));
          const message = window.utils.getMeta.translations(
            get(err, 'errors.code', 'PGS-CHM-00001'),
          );
          dispatch(
            showModal({
              modalType: 'RetryPushSession',
              props: {
                message,
                onRetry: () => window.location.reload(),
              },
            }),
          );
        });
      if (data.response.lasttouch && data.response.lasttouch.profile) {
        setProfileLastTouch(data.response.lasttouch.profile);
      }
      dispatch(setProfile(data.response.paywayProfile));
      dispatch(setInfo(data.response));
      return data.response;
    })
    .catch(() => -1);

export const userModify = data => async dispatch => {
  const entry = data;
  const result = await getModify(data);

  const status = get(result, 'response.status', get(result, 'status', '1'));
  const code = get(result, 'response.code', false);
  if (status === '0') {
    if (code === 'update_successful') {
      dispatch(setUserModify(entry));
    }
    if (code === 'userexist') {
      dispatch(setErrorEmailExist(data.response));
    }
  }
};

export const userModifyWithPass = (data, params) => async dispatch => {
  dispatch({ type: COMPLETE_MY_INFO_PENDING });
  const result = await userCompleteModify(data, params);
  const status = get(result, 'status', get(result, 'status', '1'));
  const code = get(result, 'code', false);
  if (status === '0') {
    if (code === 'update_successful') {
      dispatch({ type: COMPLETE_MY_INFO_SUCCESS, data: {} });
      dispatch(setUserModify(params));
      if (result?.lasttouch) {
        if (result.lasttouch.profile)
          setProfileLastTouch(result.lasttouch.profile);
        if (result.lasttouch.favorited)
          setProfileLastTouchFavorited(result.lasttouch.favorited);
      }
      return { ok: true };
    }
  }
  dispatch({ type: COMPLETE_MY_INFO_ERROR, error: result });
  return { ok: false, result };
};

// Devices
export const deviceList = (config, data) => dispatch => {
  const dataRequest = new DeviceListTask(config, data);
  RequestManager.addRequest(dataRequest).then(item => {
    dispatch(setDevices(item.response.devices));
  });
};

export const fetchDevicesByPurchaseId = (config, params) => dispatch => {
  const dataRequest = new DeviceListTask(config, params);
  RequestManager.addRequest(dataRequest).then(data => {
    const devices = {
      purchase_id: params.purchase_id,
      devices: data.response.devices,
    };
    dispatch(setDevicesByPurchaseId(devices));
  });
};

// RentHistory
export const rentHistory = config => dispatch => {
  const dataRequest = new RentHistoryTask(config);
  RequestManager.addRequest(dataRequest).then(data => {
    dispatch(setRentHistory(data.response));
  });
};

// Payway
export const fetchPaywayData = config => dispatch => {
  const dataRequest = new PaywayDataTask(config);
  RequestManager.addRequest(dataRequest).then(data => {
    dispatch(setPaywayData(data.response));
  });
};

export const fetchPaywayProfile = (config, params) => dispatch => {
  const dataRequest = new PaywayProfileTask(config, params);
  RequestManager.addRequest(dataRequest).then(data => {
    dispatch(setPaywayProfile(data.response));
  });
};

export const fetchPaywayListPaymentMethod = config => dispatch => {
  const dataRequest = new PaywayListPaymentMethodTask(config);
  RequestManager.addRequest(dataRequest).then(data => {
    dispatch(setPaywayListPaymentMethod(data.response));
  });
};

export const removeUserSusc = purchaseId => dispatch => {
  dispatch(setRemoveUserSusc(purchaseId));
};

// ControlPin
export const fetchStatusControlPin = (config, user) => dispatch => {
  const dataRequest = new StatusControlPinTask(config, {
    user_id: user.user_id,
  });
  RequestManager.addRequest(dataRequest).then(data => {
    dispatch(setStatusControlPin(data.response));
  });
};

export const fetchActiveControlPin = (config, params) => dispatch => {
  const dataRequest = new SetControlPinTask(config, params);
  RequestManager.addRequest(dataRequest).then(data => {
    dispatch(setConfirmControlPin(data.response));
  });
};

export const fetchRemindControlPin = (config, params) => dispatch => {
  const dataRequest = new RemindControlPinTask(config, params);
  RequestManager.addRequest(dataRequest).then(data => {
    dispatch(setRemindControlPin(data.response));
  });
};

export const removeRemindControlPin = () => dispatch => {
  dispatch(removeRemind());
};

export const updateControlPin = data => dispatch => {
  dispatch(setUpdateControlPin(data));
};

export const SET_USER_SUBSCRIPTIONS = 'SET_USER_SUSCRIPTIONS';
export const fetchUserSubscriptions = userToken => async dispatch => {
  try {
    const { data: subscriptionsResp } = await getPaywayProfileService(
      userToken,
    );
    if (subscriptionsResp?.response?.subscriptions) {
      const subscriptionsMapped = subscriptionsResp?.response?.subscriptions.map(
        sub => sub?.provider,
      );
      dispatch({ type: SET_USER_SUBSCRIPTIONS, payload: subscriptionsMapped });
      return {
        subscriptions: subscriptionsMapped,
        paymentMethods: subscriptionsResp?.response?.paymentMethods,
      };
    }
    return { subscriptions: [], paymentMethods: [] };
  } catch (error) {
    console.log(error, 'USER SUBSCRIPTIONS');
    return { subscriptions: [], paymentMethods: [] };
  }
};
